const commodities = {
  gas: 1,
  energy: 2,
  energyGas: 3,
};

export { commodities };
